import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

// Import your graduation photos
import Bachelor1 from "./image/Bachelor1.jpg";
import Master1 from "./image/Master.jpg";
import Bachelor2 from "./image/Bachelo2.jpg";
import Master2 from "./image/Master2.png";
import Bachelor3 from "./image/Bachelor3.jpg";
import Bachelor4 from "./image/Bachelor4.jpg";
import media from "./image/media.png";
import Master from "./image/Master.png";
import Master3 from "./image/Master3.jpg";
import Master4 from "./image/Master4.jpg";
import Master5 from "./image/Master3.png";
import Master6 from "./image/Master.jpeg";
import Master7 from "./image/Master1.jpeg";
import Bachelor5 from "./image/Bachelor.jpg";
import Speaker from "./image/speaker.jpeg";
function NewsCard({ image, title, text, maxLength = 350 }) {
  const [expanded, setExpanded] = useState(false);

  const shortText =
    text.length > maxLength ? text.substring(0, maxLength) + "..." : text;

  return (
    <div className="bg-white rounded-2xl shadow-md p-6 mb-6 text-black d-flex flex-column h-100">
      <img
        src={image}
        alt={title}
        className="rounded-xl shadow w-100 h-64 object-cover mb-4"
      />
      <h3 className="text-2xl font-semibold">{title}</h3>
      <p className="text-gray-600 mt-2 flex-grow">
        {expanded ? text : shortText}
      </p>
      {text.length > maxLength && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="text-blue-600 mt-2 font-medium"
          style={{ background: "none", border: "none", cursor: "pointer" }}
        >
          {expanded ? "Read less ▲" : "Read more ▼"}
        </button>
      )}
    </div>
  );
}

export default function News() {
  return (
    <div
      style={{
        marginTop: 50,
        color: "white",
        fontSize: 25,
        fontFamily: "serif",
      }}
    >
      <Container>
        <h2 className="text-3xl font-bold text-center mb-8" style={{ textDecoration: "underline" }}>News & Updates</h2>
<br />
<Row>
            
  <br/>     

          <Col xs={12} md={6}>
            <NewsCard
              image={Speaker}
              title="🌟 Guest Speaker at IEEE ELEVATE Career Talks"
              text={`I had the privilege of being invited by the IEEE MIST SB WIE Affinity Group to speak at their IEEE ELEVATE Career Talks. This event brought together curious minds, passionate students, and future innovators, and I am grateful to have been part of such a vibrant initiative.

In my talk, “Borders and Breakthroughs: The Erasmus Mundus Journey to Intelligent Robotics, Research, and Global Collaboration”, I shared my path as an Erasmus Mundus scholar and how the program has shaped my journey across countries, cultures, and research opportunities. I reflected on the challenges I faced, the lessons I learned, and how these experiences helped me grow as a researcher in intelligent robotics. 🌍🤖

I extend my heartfelt thanks to the organizers for their dedication in making this session possible, and a special appreciation to Aminul Sir for his kind words and encouragement. I also want to sincerely thank all the participants who joined the session, asked thoughtful questions, and engaged in meaningful discussions. I truly hope that my experiences will serve as a source of guidance and motivation as they build their own careers in research and innovation. 💜

This opportunity reminded me of why I believe so strongly in global collaboration and knowledge exchange. When we share our journeys openly, we not only inspire others but also learn new perspectives ourselves. It is this spirit of cooperation and curiosity that continues to drive progress in robotics, research, and beyond.`}
            />
          </Col>
            </Row>
        <Row>
            
       

          <Col xs={12} md={6}>
            <NewsCard
              image={Master1}
              title="🎓 Master’s Graduation"
              text={`I’m thrilled to share that I’ve graduated with a Master’s degree in Robotics from the Erasmus Mundus Joint Master Degree in Intelligent Field Robotic Systems (IFRoS)!

IFRoS Master program has been a life-changing journey for me, not only academically and professionally but also personally. 
During the first two semesters at Universitat de Girona, I developed a strong foundation in robotics through a combination of theoretical learning and hands-on experience in path planning, robot localization, robotic intervention, and computer vision. In the third semester at Eötvös Loránd University, I deepened my expertise in sensor fusion, deep learning, vehicle sensor systems, and artificial intelligence, while working on hands-on projects. Studying alongside a diverse group of international peers and learning from leading researchers has enhanced my technical skills, expanded my perspective, improved my adaptability, and strengthened my ability to collaborate across cultures.

My thesis, "Enhancing Deep Reinforcement Learning with Curriculum Learning for Robotic Tasks," demonstrated how curriculum learning can significantly enhance the performance of Deep Reinforcement Learning agents, leading to faster convergence, improved training stability, and higher success rates in task completion under sparse-reward, continuous control environments. 
 I would like to express my deepest gratitude to my academic supervisor Dr. Zoltán Istenes and industrial supervisor Dr. Daniel Horváth for their constant support, guidance, and mentorship. Your insights and encouragement played a vital role in my growth as a researcher. I am sincerely grateful to HUN-REN SZTAKI (Institute for Computer Science and Control) for providing me with the opportunity to conduct my master’s thesis within their esteemed research environment.

Special thanks to Prof. Narcis Palomeras and Prof. Nuno Gracias, the coordinators and professors of the IFRoS program, for their leadership and dedication in shaping such an impactful and international academic experience. 

I’m also grateful to all the professors, colleagues, and friends who enriched this journey, and a heartfelt thank you to Imma Güell and Réka Kökény for their exceptional administrative support that helped everything run smoothly.

It wasn’t easy being away from home for the first time—far from familiar faces, food, and comfort. 
But I kept reminding myself: “It’s not hard—it’s just new. 😇 ”
And with that mindset, I embraced the challenges, learned deeply, and grew beyond my expectations. 
Now excited to take the next step toward impactful research and innovation! 🚀`}
            />
          </Col>
           <Col xs={12} md={6}>
            <NewsCard
              image={Master7}
              title="🪧 Master’s Thesis Poster Presentation"
              text={`I had the wonderful opportunity to present my Master’s thesis poster titled
“Enhancing Deep Reinforcement Learning with Curriculum Learning for Robotic Tasks”
at the University of Girona (UdG) as part of the IFRoS program’s academic presentation activities.

📊 The presentation included the methodology, experimental results, and visual insights into how robotic learning can be improved using adaptive strategies.

🌿 Sharing my work outdoors on the beautiful Girona campus, surrounded by fellow students, professors, and researchers, made the experience even more rewarding. It sparked valuable discussions and meaningful feedback.

🙏 I’m truly thankful to the IFRoS consortium and UdG for fostering such engaging academic spaces. This poster defense marks an exciting step forward in my robotics research journey! 🤖💡`}
            />
          </Col>
            </Row>         
            <Row>
          <Col xs={12} md={6}>
            <NewsCard
              image={Master6}
              title="🎓 Master's Thesis Defense"
              text={`On June 19, 2025, I successfully defended my Master’s thesis as part of the Erasmus Mundus Joint Master Degree in Intelligent Field Robotic Systems (IFRoS) 🎉


My research explored how a curriculum-based learning strategy can improve robot training in failure-prone scenarios — leading to faster convergence, higher success rates, and more stable performance in real-world robotic environments.

The defense presentation showcased a comparative analysis of various methods, including my novel curriculum-integrated framework, evaluated across multiple robotic manipulation tasks. The support and feedback from my professors and peers made this day especially meaningful 🙏

It was an incredibly proud moment to reflect on this journey — from Girona to Budapest — filled with challenges, growth, and accomplishments. I’m grateful to IFRoS, ELTE, SZTAKI, and UdG for guiding me through this transformative academic experience.

Excited for what comes next in the world of robotics, learning, and innovation! 🚀`}
            />
          </Col>

          <Col xs={12} md={6}>
        
            <NewsCard
              image={media}
              title="🎓 Thesis Presentation at HUN-REN SZTAKI"
              text={`I had the opportunity to present my Master’s thesis at the HUN-REN SZTAKI – Institute for Computer Science and Control, Hungary, during the official Master's Thesis Presentation Webinar.

My thesis is titled
“Enhancing Deep Reinforcement Learning with Curriculum Learning for Robotic Tasks” 🤖📚

In this work, I explored how curriculum learning can be used to improve performance for deep reinforcement learning. The approach dynamically adjusts task difficulty and separates successful and failed experiences, making the training process faster and more stable.

This method helps robotic agents learn more effectively in failure-prone and sparse-reward environments, and improves performance in real-world tasks.

It was an amazing experience to present my work alongside fellow researchers and receive valuable feedback. This presentation marks a key milestone in my academic journey, and motivates me to continue exploring robotics, intelligent systems, and adaptive learning. 🚀

Special thanks to my supervisor Dr. Dániel Horváth for his continuous support and mentorship.`}
            />
          </Col>
               </Row>
               <Row>
                <Col xs={12} md={6}>
            <NewsCard
              image={Master3}
              title="🏢 Company Visit – Bosch & More with IFRoS Team"
              text="As part of the Intelligent Field Robotic Systems (IFRoS) Erasmus Mundus Joint Master’s program, I had the amazing opportunity to take part in a two-day visit organized by Eötvös Loránd University (ELTE) in Budapest.

We had the chance to meet and learn from some of the top scientific and industrial players in robotics and automation, including Bosch Magyarország, GIM Robotics, and HUN-REN SZTAKI. The event featured presentations, company visits, and robot demonstrations from drones and four-legged robots to advanced manipulators 🤖🚁

It was a fantastic experience to explore real-world applications of what we are learning in class, and to see how cutting-edge technologies are shaping the future of robotics and intelligent systems.

I’m grateful to Prof. Zoltán Istenes and the entire ELTE team for organizing such an inspiring and professionally enriching visit 🙏
Looking forward to more hands-on experiences like this with the IFRoS family! 🚀"
            />
          </Col>

          <Col xs={12} md={6}>
            <NewsCard
              image={Master4}
              title="🚁 DroneDays 2024 – Hands-On Learning in Zagreb"
              text="I had the incredible opportunity to attend the 4th DroneDays Workshop hosted at the University of Zagreb, as part of the Intelligent Field Robotic Systems (IFRoS) Master’s program.

The event brought together industry experts, researchers, and students to explore the latest trends in aerial robotics, autonomous drones, and real-world applications of UAV technology. Alongside live demonstrations and company booths, we took part in specialized lectures that gave us deep insight into cutting-edge technologies and research directions.

It was an intense and exciting few days filled with learning, networking, and fun moments.😄🚁

Grateful for this opportunity to grow both technically and professionally, and to connect with so many brilliant minds in the field of robotics and autonomous systems"
            />
          </Col>
        </Row>
<Row>
          <Col xs={12} md={6}>
            <NewsCard
              image={Master2}
              title="🤖 Beginning My 3rd Semester at ELTE, Budapest"
              text="I am excited to share that I have officially started my third semester at Eötvös Loránd University (ELTE), Budapest, as part of the Erasmus Mundus Joint Master’s Degree in Intelligent Field Robotic Systems (IFRoS). This semester marks an exciting new chapter in my academic journey, with a strong focus on self-landing vehicles ✈️ and autonomous systems 🤖. The courses and projects are designed to provide in-depth knowledge of advanced robotics, sensor fusion, artificial intelligence, and control strategies required to make autonomous vehicles operate safely and intelligently in complex real-world environments. Studying in Budapest has also given me the opportunity to collaborate with talented peers from around the world 🌍, enriching both my technical expertise and cultural experiences. I look forward to embracing the challenges ahead, contributing to innovative projects, and preparing myself for impactful research and future applications in the field of intelligent robotics 🚀."
            />
          </Col>
           <Col xs={12} md={6}>
             <NewsCard
              image={Master5}
              title="🏭 Industry Visit to TAVIL"
              text={`As a student of the IFRoS Master’s program, I had the amazing opportunity to visit TAVIL, one of our associated industry partners and a global leader in automated packaging, palletizing, and handling systems.

Together with my IFRoS classmates and students from the MIRS Master’s program, we explored TAVIL’s cutting-edge facilities, saw real-world robotics in action, and learned how automation systems are developed and integrated into large-scale industrial operations 🤖📦

It was truly inspiring to see how the theories and tools we study in class come to life in professional settings. From their advanced R&D to turnkey automation solutions, the visit helped us understand how robotics is used to solve real business challenges.

One of the best parts was getting to talk with TAVIL engineers and experts directly. Their insights made the experience even more valuable, giving us a deeper understanding of how technical knowledge blends with real-world problem-solving and innovation.

Huge thanks to IFRoS and TAVIL for making this visit possible 🙏
Looking forward to more learning experiences like this that bring us closer to the future of robotics and intelligent systems 🚀`}/>
          </Col>
    
   </Row>
          <Row>

        {/* Second row */}
     
          <Col xs={12} md={6}>
             <NewsCard
              image={Master}
              title="🎉 IFRoS Induction Week – Girona"
              text={`I am so happy to begin my Erasmus Mundus journey as a student of the Intelligent Field Robotic Systems (IFRoS) Master’s program 🌍✨

Our very first week kicked off with a fun and inspiring Induction Week at the University of Girona in Spain. It was filled with new faces, joyful moments, team-building activities, and exciting sessions that introduced us to the program, the professors, and each other 🤝

Meeting my classmates from all over the world, each with unique backgrounds and the same passion for robotics 🤖, made me feel instantly at home. We shared laughs, snacks, ideas, and goals as well as this picture captures just one of the many light-hearted and lively moments from the week 📸

This is the beginning of a new adventure for me, and I am feeling truly grateful and motivated to explore, learn, and grow with this amazing group 🚀💡

Let’s go, IFRoS! 💙`}/>
          </Col>
    
            <Col xs={12} md={6}>
             <NewsCard
              image={Bachelor2}
              title="📚 Beginning My Master’s Degree"
              text={`By the Grace of Almighty Allah, I am excited to inform you all that I have been awarded the prestigious Erasmus Mundus Joint Master Scholarship in Intelligent Field Robotics System (IFRos). 

The IFRoS Master program is designed for a new generation of engineers who want to create advanced applications and technologies to improve field robots. This program provides a unique opportunity to explore the latest methods and technologies that drive intelligent field robots. IFRos is a joint master's degree program that spans two years and is coordinated by the University of Girona (UdG, Spain), Eötvös Loránd University (ELTE, Hungary), and the University of Zagreb (UNIZG, Croatia).

I really appreciate the European Union for providing me with such an incredible opportunity. I'd like to thank my family, friends, and teachers. None would have existed without their support. I am eager to learn, grow, and contribute to the vibrant academic community at IFRoS and to collaborate with peers and faculty members on groundbreaking robotics field projects.

As I embark on this new chapter of my life, please keep me in your prayers.`}/>
          </Col>
             </Row>
              <Row>
          <Col xs={12} md={6}>
            <NewsCard
              image={Bachelor1}
              title="🎓 Bachelor Graduation"
              text="I am delighted to share that I have successfully completed my Bachelor of Science in Electrical, Electronic, and Communication Engineering (EECE). This milestone marks the foundation of my academic and professional journey, where I gained strong fundamentals in electronics, communication systems, signal processing, and embedded systems. During my undergraduate years, I had the opportunity to work on projects that sparked my passion for Deep Learning 🤖, Embedded Systems ⚡, Wireless Communication 📡, and Intelligent Systems 🌐, while also strengthening my problem-solving and teamwork skills. I am deeply grateful to my professors, peers, family, and friends for their constant support throughout this journey. This achievement has not only shaped my technical expertise but also fueled my ambition to pursue advanced studies and impactful research in the field of intelligent systems. 🌟 Celebrated the successful graduation from Bachelor! A proud moment filled with joy and achievements."
            />
          </Col>
           
           
                <Col xs={12} md={6}>
            <NewsCard
              image={Bachelor4}
              title="🥇 1st Position – Python Programming Competition"
              text="I am proud to have secured first position in a Python Programming Contest organized by the MIST Innovation Club in collaboration with Bohubrihi, one of the leading online education platforms in Bangladesh. The competition brought together students from different departments at the Military Institute of Science and Technology (MIST) and challenged us to solve a variety of programming problems using Python.

I teamed up with Saraf Anika from the Department of Computer Science and Engineering (CSE), while I represented the Department of Electrical, Electronic, and Communication Engineering (EECE). Together, we tackled a range of problems involving Python fundamentals, algorithmic thinking, and real-world logic. It was an exciting and intense experience that required both strong technical understanding and effective teamwork.

Participating in this contest helped me deepen my knowledge of Python and improve my ability to think critically under pressure. It also inspired me to further explore programming applications in fields such as artificial intelligence, robotics, and embedded systems.

Winning this competition was a very meaningful achievement in my academic journey. It strengthened my confidence, enhanced my collaborative skills, and reinforced my passion for problem-solving and continuous learning in the field of technology."
            />
          </Col>
          </Row>
<Row>
     <Col xs={12} md={6}>
            <NewsCard
              image={Bachelor5}
              title="🌟 Hosting at ICEEICT 2021"
              text="I had the incredible honor of serving as a hostess for three sessions at the 5th International Conference on Electrical Engineering and Information & Communication Technology (ICEEICT 2021). Organized by the Department of Electrical, Electronic & Communication Engineering at the Military Institute of Science and Technology (MIST) 🎓, the event brought together brilliant researchers, distinguished guests, and industry experts from across the world 🌍📚. My role allowed me to warmly welcome speakers, introduce cutting-edge research presentations, and ensure smooth coordination throughout the sessions 🤝🗂️. Alongside this, I was also a proud member of the Inauguration Committee ✨, where I contributed by preparing slides and supporting the opening ceremony 💻🎞️. This combined experience not only enhanced my communication, leadership, and organizational skills 💡 but also gave me the opportunity to connect with inspiring academicians and professionals 👩‍🏫👨, gaining valuable insights into the latest advancements in electrical engineering and communication technology ⚡📡. Representing my department in such a prestigious international platform was a true moment of pride 💚, and it will remain an unforgettable milestone in my academic and professional journey 🚀"
            />
          </Col>
          <Col xs={12} md={6}>
            <NewsCard
              image={Bachelor3}
              title="🌐 IEEE MIST Student Branch — Webmaster"
              text="In 2021, I had the opportunity to serve as the WebMaster for the IEEE MIST Student Branch Women in Engineering Executive Committee (WIE EX-COM). In this role, I was responsible for managing and maintaining the branch’s digital platforms, including updating event announcements, publishing technical content, and supporting outreach through an organized web presence.

This experience strengthened my skills in technical communication, UI/UX coordination, and collaborative leadership, while also allowing me to contribute meaningfully to initiatives promoting women in engineering and inclusive innovation.

Being part of this vibrant community not only enhanced my technical and organizational abilities, but also gave me the chance to work alongside passionate peers and mentors committed to creating positive change in STEM."
            />
          </Col>
        </Row>
        <br/><br/>
      </Container>
    </div>

  );
}
